import { MAX_STRING_CHARACTERS } from "./campaign-name-validation";

const MAX_SUFFIX = 1000;

const generateUniqueCampaignName = (baseName: string, existingNames: string[]): string => {
    const normalizedExistingNames = existingNames.map((name) => name.toLowerCase().trim());
    let candidateName = baseName;
    let suffix = 2;

    if (!normalizedExistingNames.includes(candidateName.toLowerCase().trim())) {
        return candidateName;
    }

    while (true) {
        const suffixText = ` (${suffix})`;
        const maxBaseLength = MAX_STRING_CHARACTERS - suffixText.length;
        const truncatedBase = baseName.length > maxBaseLength ? baseName.substring(0, maxBaseLength).trim() : baseName;

        candidateName = `${truncatedBase} ${suffixText}`;

        if (!normalizedExistingNames.includes(candidateName.toLowerCase().trim())) {
            return candidateName;
        }

        suffix++;

        if (suffix > MAX_SUFFIX) {
            return `${baseName.substring(0, maxBaseLength - 10).trim()} (${Date.now()})`;
        }
    }
};

export const generateCampaignNameFromDomain = (domain: string, existingCampaignNames: string[]): string => {
    const baseName = domain.trim();
    return generateUniqueCampaignName(baseName, existingCampaignNames);
};
